import React from 'react';
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext';
import { Stack } from 'src/viewLayer/components/DesignSystem';
import { MagicLink } from 'src/viewLayer/components/shared/MagicLink/MagicLink';
import { SocialLogin, TermsAndConditions } from 'src/viewLayer/components/shared/SharedViewComponent';
import { showMagicLink } from 'src/viewLayer/navigation';

import Footer from './Footer';
import Header from './Header';
import {
  BackgroundItemsContainer, Card, CardContainer, CardLayout,
} from './index.styled';

const WebCardLayout = ({
  appType,
  BackgroundItems,
  children,
  email,
  hideTermsAndConditions = false,
  Image,
  isPasswordPage,
  subtitle,
  title,
}) => (
  <CardLayout align="center">
    <CardContainer align="center" className="CardLayoutComponent">
      <Card
        alignItems="center"
        padding={{
          small: [60, 8, 24, 8],
          xxsmall: [36, 8, 10, 8],
        }}
      >
        <Header Image={Image} subtitle={subtitle} title={title} />
        {children}
        {isPasswordPage
          ? <MagicLink email={email} /> : <SocialLogin appType={appType} />}
        { !hideTermsAndConditions && <TermsAndConditions /> }
      </Card>
      <BackgroundItemsContainer>
        {BackgroundItems && BackgroundItems.map((BackgroundItem, index) => (
            <BackgroundItem key={index} />
        ))}
      </BackgroundItemsContainer>
    </CardContainer>
    <Footer />
  </CardLayout>
);

const NativeMobileCardLayout = ({
  children, email, Image, isPasswordPage, subtitle, title,
}) => (
  <CardLayout align="center">
    <CardContainer webview>
      <Stack
        alignItems="center"
        padding={{
          small: [80, 5, 24, 5],
          xxsmall: [80, 0, 10, 0],
        }}
      >
        <Header Image={Image} subtitle={subtitle} title={title} />
        {children}
      </Stack>
      {(isPasswordPage && showMagicLink()) && <MagicLink email={email} />}
    </CardContainer>
  </CardLayout>
);

export default (properties) => {
  const { devicePath } = useAppConfigContext();
  return (
    devicePath === 'login' ? <WebCardLayout {...properties} />
      : <NativeMobileCardLayout {...properties} />
  );
};
